/**
 * URL 配置
 * 数据来源: build/env.config.js (通过 webpack DefinePlugin 注入)
 */
const cfg = JSON.parse(process.env.ENV_CONFIG || '{}')

export default {
  url:     cfg.baseUrl,
  chatUrl: cfg.chatUrl,
  imgUrl:  cfg.imgUrl,
}



// WEBPACK FOOTER //
// ./src/fetch/url.js